import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[appSchedulerListDirective]',
  standalone: true,
})
export class SchedulerListDirective implements OnInit, OnDestroy {
  @Input() set orientation(value: string) {
    this.orientationSubject.next(value);
  }

  @Input() set listSize(value: number) {
    this.listSizeSubject.next(value);
  }

  private orientationSubject = new BehaviorSubject<string>(null);
  private listSizeSubject = new BehaviorSubject<number>(null);
  private subscription: Subscription;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.renderer.addClass(this.el.nativeElement, 'tw-mx-3');

    this.subscription = combineLatest([
      this.orientationSubject.asObservable().pipe(distinctUntilChanged()),
      this.listSizeSubject.asObservable().pipe(distinctUntilChanged()),
    ]).subscribe(([orientation, listSize]) => {
      this.updateClasses(orientation, listSize);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateClasses(orientation: string, listSize: number): void {
    if (orientation === 'horizontal') {
      this.changeToHorizontal();
    } else {
      this.changeToVertical();
    }
    // if (orientation === 'vertical' || listSize === 0) {
    //   this.renderer.removeClass(this.el.nativeElement, 'list-group-horizontal');
    //   this.renderer.removeClass(this.el.nativeElement, 'tw-py-5');
    //
    //   this.renderer.addClass(this.el.nativeElement, 'align-items-center');
    //   this.renderer.addClass(this.el.nativeElement, 'tw-py-2');
    // }

    if (listSize === 1) {
      this.renderer.addClass(this.el.nativeElement, 'list-with-one-item');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'list-with-one-item');
    }

    if (listSize === 0) {
      this.renderer.addClass(this.el.nativeElement, 'list-empty');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'list-empty');
    }
  }

  changeToHorizontal(): void {
    // this.renderer.addClass(this.el.nativeElement, 'list-group-horizontal');
    this.renderer.addClass(this.el.nativeElement, 'list-horizontal');

    // this.renderer.removeClass(this.el.nativeElement, 'align-items-center');
    this.renderer.removeClass(this.el.nativeElement, 'list-vertical');
  }

  changeToVertical(): void {
    // tw-space-y-4 tw-flex tw-justify-center tw-px-0 tw-items-center
    this.renderer.addClass(this.el.nativeElement, 'list-vertical');

    // this.renderer.removeClass(this.el.nativeElement, 'list-group-horizontal');
    this.renderer.removeClass(this.el.nativeElement, 'list-horizontal');
  }
}
